export default "__VITE_ASSET__Qv__vjjD__"